import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CardSeplag from "../../../../../components/CardSeplag";
import {
  buscarAnaliseIndicador,
  buscarAnalisePrograma,
  buscarAnaliseProgramaDevolutivo,
} from "../../../../../service/Rag/lançamento";
import AnaliseGeralSeplag from "./AnaliseGeral/AnaliseGeralSeplag";
import AnaliseIndicadorSeplag from "./AnaliseIndicador/AnaliseIndicadorSeplag";
import DevolutivaUnidadeSetorial from "./DevolutivaUnidadeSetorial/DevolutivaUnidadeSetorial";
import AnaliseGeralProgramaSeplag2024 from "./componentprograma-2024/AnaliseGeralProgramaIndicadorSeplag2024";
import AnaliseGeralProgrSeplag2024 from "./componentprograma-2024/AnaliseGeralProgrSeplag2024";
import CardSeplagScrol from "../../../../../components/CardSeplag/CardSeplagScrol";

const AnaliseProgramaSeplag = ({ dadosItemPrograma, parametroExercicio, form }) => {
  const [data, setData] = useState({
    ListaAnaliseIndicadores: [],
    ListaAnalisePrograma: [],
    ListaAnaliseProgramaDevolutiva: [],
  });
  //console.log("Linha19:",data)  
  //console.log("InfoForm",form)
  //console.log("IdenPTAFIPLAN>>", form.children[0].idenPtaFiplan)  //Recuperado da ArvoreRAG
  const [permissionAnaliseIndicador, setPermissionAnaliseIndicador] = useState({
    edit: false,
    view: false,
  });
  const [permissionUserAnaliseGeral, setPermissionUserAnaliseGeral] = useState({
    edit: false,
    view: false,
    devo: false,
  });
  const [permissionAnaliseGeral, setPermissionAnaliseGeral] = useState({
    edit: false,
    view: false,
  });
  const [permissionUserDevolutiva, setPermissionUserDevolutiva] = useState({
    edit: false,
    view: false,
  });
  const [atualizarData, setAtualizarData] = useState(true);
  const [indicadores, setIndicadores] = useState([]);
  const userPerfil = useSelector((state) => state.userReducer.user);

  let history = useHistory();
 
  const permission = (parametroExercicio) => {
    let dateNow = new Date();
    let cronogramaVigente = "INATIVO";
    let podeEditarAnaliseIndicador;
    let podeEditarAnaliseGeral;
    let podeEditarDevolutiva;
    let statExercicio = "INATIVO";
    let view = false;
    let edit = false;
    let devo = false;
    let viewdev = false;
    let editdev = false;

    const authorities = userPerfil.contaAcesso.authorities; 

    // console.log("Perfil:", userPerfil.contaAcesso.usuarioLogadoFormatado, " ", authorities)
    for (let cronograma of parametroExercicio.cronograma) {
      let dataFinal = new Date(
        Number(cronograma.dataFinal.split("/")[2]),
        Number(cronograma.dataFinal.split("/")[1] - 1),
        Number(cronograma.dataFinal.split("/")[0])
      );
      if (dataFinal >= dateNow) cronogramaVigente = "ATIVO";
    }
    let isADM = false;
    for (let i = 0; i < authorities.length; i++) {
      if (authorities[i].nomeRole === "MONRL_ADMIN_CENTRAL" 
        || authorities[i].nomeRole === "MONRL_ANALISTA"
        ) {
        podeEditarAnaliseIndicador = true;
        podeEditarAnaliseGeral = true;
        // console.log("EntrouPelaRole:", authorities[i].nomeRole)
        if (authorities[i].nomeRole === "MONRL_ADMIN_CENTRAL")
          { isADM = true}
      } else if (authorities[i].nomeRole === "MONRL_ADMIN_SETORIAL"
          || authorities[i].nomeRole === "MONRL_LANCAMENTO"        
        ) {
        podeEditarDevolutiva = true;
      }
    }
    if (parametroExercicio.exercicio.statExercicio === "ATIVO") statExercicio = "ATIVO";

    if (
      cronogramaVigente === "ATIVO" &&
      (podeEditarAnaliseIndicador === true || podeEditarAnaliseGeral === true) &&
      statExercicio === "ATIVO"
    ) {
      view = true;
      edit = true;
      devo = false;
      // console.log("Parte104")
      if (isADM === true)
      { devo = true}
    } else if (form.permissaoItem === "E" || userPerfil.contaAcesso.pessoa.idenPessoa === form.idenPessoaResp
      || podeEditarDevolutiva === true
    ) {
      edit = false;
      view = true;
      devo = true;
      // console.log("Parte108")
    }

    //view = true; //para testes da Analise
    //edit = true; //para testes da Analise
    //console.log("SubiuPermissaoUserAnaliseGeral",view,edit)
    setPermissionUserAnaliseGeral({ view: view, edit: edit, devo: devo });
    

    setPermissionAnaliseIndicador({ view: view, edit: edit });
    setPermissionAnaliseGeral({ view: view, edit: edit });

    // console.log("Linha120: ", view, edit)
    // console.log("permissionUserAnaliseGeral",permissionUserAnaliseGeral.view, permissionUserAnaliseGeral.edit)
    view = true;
    edit = false;

    //debugger
    //console.log("podeEditarDevolutiva",podeEditarDevolutiva)
    if (
      cronogramaVigente === "ATIVO" && 
      (podeEditarDevolutiva === true || form.permissaoItem === "E" || userPerfil.contaAcesso.pessoa.idenPessoa === form.idenPessoaResp) &&
      statExercicio === "ATIVO"
    ) {
      viewdev = true;
      editdev = true;
    } else {
      viewdev = true;
      editdev = false;
    }

    //view = true; //para testes da Devolutiva
    //edit = false; //para testes da Devolutiva
    setPermissionUserDevolutiva({ view: viewdev, edit: editdev });

    
    // console.log("permissionUserDevolutiva",permissionUserDevolutiva.view, permissionUserDevolutiva.edit)
  };

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  useEffect(() => {
    permission(parametroExercicio);
    let _indicadores = [];
    dadosItemPrograma.dadosItemRag.objetivos.map((element) =>
      element.indicadores.map((_element) => {
        let filterByID = _indicadores.filter((item) => {
          return item.idenIndicador === _element.idenIndicador;
        });

        if (filterByID.length <= 0) _indicadores.push(_element);
      })
    );
    setIndicadores(_indicadores);
  }, []);

  useEffect(() => {
    if (atualizarData === true) {
      buscarAnaliseIndicador(dadosItemPrograma.dadosItemRag.idenPrograma).then((_res) => {
        //console.log("RetornoOrdenacaoTRES:",_res)
        setData((prevState) => ({
          ...prevState,
          ListaAnaliseIndicadores: _res.sort((a, b) => {
            if (a.idenAnaliseIndicador > b.idenAnaliseIndicador) {
              return 1;
            }
            if (a.idenAnaliseIndicador < b.idenAnaliseIndicador) {
              return -1;
            }
            return 0;
          }),
          OrgCentralnumber: 5,
          listaAnalisetotalElements: 6
        }));
      });

      buscarAnalisePrograma(dadosItemPrograma.dadosItemRag.idenPrograma).then((_res) => {
        //console.log("RetornoOrdenacaoDOIS:",_res)
        setData((prevState) => ({
          ...prevState,
          ListaAnalisePrograma: _res.sort((a, b) => {
            if (a.idenAnalisePrograma > b.idenAnalisePrograma) {
              return 1;
            }
            if (a.idenAnalisePrograma < b.idenAnalisePrograma) {
              return -1;
            }
            return 0;
          }),
        }));
      });

      buscarAnaliseProgramaDevolutivo(dadosItemPrograma.dadosItemRag.idenPrograma).then((_res) => {
        //console.log("RetornoOrdenacaoUM:",_res)
        setData((prevState) => ({
          ...prevState,
          ListaAnaliseProgramaDevolutiva: _res.sort((a, b) => {
            if (a.idenAnalisePrograma > b.idenAnalisePrograma) {
              return 1;
            }
            if (a.idenAnalisePrograma < b.idenAnalisePrograma) {
              return -1;
            }
            return 0;
          }),
        }));
      });
      setAtualizarData(false);
    }
  }, [atualizarData]);

    //Controle para identificar se o ano eh igual ou superior a 2024  
  const exercicio2024 = parametroExercicio.exercicio.ano >= 2024 ? true : false;    

  //console.log("DEVOLUT",data.ListaAnaliseProgramaDevolutiva)
  //console.log("InformacoesPrograma",dadosItemPrograma)
  return (
    <>
      {!exercicio2024 ? (
      
        <CardSeplag>
          <ConfirmDialog breakpoints={{ "960px": "75vw", "640px": "100vw" }} style={{ width: "50vw" }} />

          <AnaliseIndicadorSeplag
            ListaAnaliseIndicadores={data.ListaAnaliseIndicadores}
            setAtualizarData={setAtualizarData}
            indicadores={indicadores}
            permissionUser={permissionAnaliseIndicador}
          />
          <AnaliseGeralSeplag
            ListaAnalisePrograma={data.ListaAnalisePrograma}
            setAtualizarData={setAtualizarData}
            dadosItemPrograma={dadosItemPrograma}
            permissionUser={permissionAnaliseGeral}
          />
          <DevolutivaUnidadeSetorial
            ListaAnaliseProgramaDevolutiva={data.ListaAnaliseProgramaDevolutiva}
            setAtualizarData={setAtualizarData}
            indicadores={indicadores}
            dadosItemPrograma={dadosItemPrograma}
            permissionUser={permissionUserDevolutiva}
          />
          <div className="p-fluid grid " style={{ margin: "1rem" }}>
            <div className="field col-12 md:col-8 ">&nbsp;</div>
            <div className="field col-12 md:col-2 "></div>

            <div className="field col-12 md:col-2 ">
              <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
            </div>
          </div>
        </CardSeplag>
      
      ): 
        (
          <CardSeplagScrol maxHeight="700px">
            {/* {console.log("PerUser",permissionUserAnaliseGeral)} */}
            <>
              <AnaliseGeralProgramaSeplag2024
                setAtualizarData  = {setAtualizarData}
                dadosItemPrograma = {dadosItemPrograma}
                permissionUser    = {permissionUserAnaliseGeral}
                ListaAnaliseAcaoDevolutiva={data.ListaAnaliseAcaoDevolutiva}
                setData           = {setData}
                data              = {data}
                indicadores       = {indicadores}
                infoUnidade       = {form.unidadeOrcamentaria}
                permissionUserDevolutiva = {permissionUserDevolutiva}
                infoPtaFiplan     = {form.children[0].idenPtaFiplan}
              />
              
              <AnaliseGeralProgrSeplag2024
                setAtualizarData  = {setAtualizarData}
                dadosItemPrograma = {dadosItemPrograma}
                permissionUser    = {permissionUserAnaliseGeral}
                ListaAnaliseAcaoDevolutiva={data.ListaAnaliseAcaoDevolutiva}
                setData           = {setData}
                data              = {data}
                indicadores       = {indicadores}
                infoUnidade       = {form.unidadeOrcamentaria}
                permissionUserDevolutiva = {permissionUserDevolutiva}
              />
            </>
          </CardSeplagScrol>
        )
    }
    </>
  );
};
export default AnaliseProgramaSeplag;
